<template>
  <v-container fluid>
    <v-row>
      <v-col lg="8" cols="12" class="mx-auto my-8">
        <v-stepper
          alt-labels
          elevation="0"
          v-model="e1"
          class="bg-transparent overflow-visible"
        >
          <v-stepper-header class="shadow-0">
            <v-stepper-step step="1" color="#344767">
              <span class="text-secondary font-weight-normal"
                >Location Info</span
              >
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2" color="#344767">
              <span class="text-secondary font-weight-normal">Address</span>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items
            class="border-radius-xl overflow-hidden shadow-lg mt-8"
          >
            <v-stepper-content
              step="1"
              class="bg-white border-radius-xl px-4 pt-4"
            >
              <v-card>
                <div>
                  <h5 class="font-weight-bolder text-h5 text-typo mb-0">
                    Location Details
                  </h5>
                  <p class="mb-0 text-sm text-body">Mandatory Info</p>
                  <v-row class="mt-2">
                    <v-col sm="6" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Location Name</label
                      >
                      <v-text-field
                        hide-details
                        v-model="locationName"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Location Type</label
                      >

                      <v-select
                        light
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                        outlined
                        hide-details
                        dense
                        :items="types"
                        v-model="locationType"
                      ></v-select>
                    </v-col>
                    <v-col sm="12" cols="12" v-if="locationType === 'Other'">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Other Location Type</label
                      >

                      <v-text-field
                        v-model="otherLocationType"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-3"></v-divider>
                  <v-row class="mt-2">
                    <v-col>
                      <h3>Location Contact</h3>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col sm="6" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Contact Name</label
                      >
                      <v-text-field
                        hide-details
                        v-model="locationContact"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Location Phone</label
                      >
                      <v-text-field
                        v-model="phoneNumber"
                        hide-details
                        max-length="11"
                        dense
                        :mask="phoneMask"
                        :rules="phoneRules"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div class="text-end">
                  <v-btn
                    :ripple="false"
                    :elevation="0"
                    class="
                      font-weight-bold
                      text-xs
                      btn-default
                      bg-gradient-default
                      py-5
                      px-6
                      mt-6
                      mb-2
                      me-2
                    "
                    color="primary"
                    @click="e1 = 2"
                  >
                    Next
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>

            <v-stepper-content
              step="2"
              class="bg-white border-radius-xl px-4 pt-4"
            >
              <v-card>
                <div>
                  <h5 class="font-weight-bolder text-h5 text-typo mb-7">
                    Address
                  </h5>
                  <v-row class="mt-2">
                    <v-col cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Address 1</label
                      >
                      <v-text-field
                        hide-details
                        v-model="address1"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. Street 111"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Address 2</label
                      >
                      <v-text-field
                        v-model="address2"
                        hide-details
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. Street 221"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col sm="6" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >City</label
                      >
                      <v-text-field
                        hide-details
                        v-model="city"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="eg. Dallas"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col sm="3" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >State
                      </label>
                      <v-text-field
                        hide-details
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="ex. TX"
                        v-model="state"
                        maxLength="2"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col sm="3" cols="12">
                      <label class="text-xs text-typo font-weight-bolder ms-1"
                        >Zip</label
                      >
                      <v-text-field
                        hide-details
                        type="number"
                        maxLength="7"
                        v-model="zip"
                        outlined
                        color="rgba(0,0,0,.6)"
                        light
                        placeholder="7 letters"
                        class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div class="d-flex">
                  <v-btn
                    :ripple="false"
                    :elevation="0"
                    class="
                      font-weight-bold
                      text-xs text-dark
                      btn-light
                      bg-gradient-light
                      py-5
                      px-6
                      mt-6
                      mb-2
                      ms-2
                    "
                    @click="e1 = 1"
                  >
                    Prev
                  </v-btn>
                  <v-btn
                    v-if="el != 1"
                    :ripple="false"
                    :elevation="0"
                    class="
                      font-weight-bold
                      text-xs
                      btn-default
                      bg-gradient-default
                      py-5
                      px-6
                      mt-6
                      mb-2
                      me-2
                      ms-auto
                    "
                    color="primary"
                    @click="addLocation"
                  >
                    Submit
                  </v-btn>
                  <v-btn
                    v-if="el == 1"
                    :ripple="false"
                    :elevation="0"
                    class="
                      font-weight-bold
                      text-xs
                      btn-default
                      bg-gradient-default
                      py-5
                      px-6
                      mt-6
                      mb-2
                      me-2
                      ms-auto
                    "
                    color="primary"
                    @click="e1 = 2"
                  >
                    Next
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { fetchObjects } from "../services/firebase-helpers";

export default {
  data() {
    return {
      e1: 1,
      locationName: "",
      phoneNumber: "",
      locationContact: "",
      locationType: "",
      otherLocationType: "",
      types: [
        "Manufacturing Facility",
        "Warehouse",
        "Oil / Energy",
        "Military / Defense",
        "Other",
      ],
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      phoneMask: "(###) ###-####",
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
            v
          ) || "Invalid phone number format",
      ],
      company: null,
    };
  },
  methods: {
    addLocation() {
      this.$store.dispatch("addLocation", {
        name: this.locationName,
        phoneNumber: this.phoneNumber,
        locationContact: this.locationContact,
        locationType:
          this.locationType === "Other"
            ? this.otherLocationType
            : this.locationType,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        zip: this.zip,
        companyId: this.company ? this.company.key : null,
      });
    },
    async getCompanyByName() {
      const comp = await fetchObjects("company");
      this.company = comp.filter(
        (c) => c.name === this.$store.state.auth.company
      )[0];
    },
  },
  async created() {
    await this.getCompanyByName();
    // this.locationName = "New Location";
    // this.phoneNumber = "8177157790";
    // this.locationContact = "John Doe";
    // this.locationType = "Manufacturing Facility";
    // this.address1 = "123 Main St";
    // this.city = "Houston";
    // this.state = "TX";
    // this.zip = "77002";
  },
};
</script>
